import { Badge } from "@nexus/ui"
import { useTranslation } from "react-i18next"
import type { OpportunityStatus } from "../../../types/opportunities.types"

const statusStyles: Record<OpportunityStatus, string> = {
  active: "border-border bg-transparent text-foreground",
  rejected: "border-destructive/20 bg-transparent text-destructive",
}

export function OpportunityStatusBadge({ status }: { status: OpportunityStatus }) {
  const { t } = useTranslation()

  return (
    <Badge variant="outline" className={statusStyles[status] ?? "border-border bg-transparent text-foreground"}>
      {t(`opportunities.status.${status}`)}
    </Badge>
  )
}
